import { render, staticRenderFns } from "./VaItemLabel.vue?vue&type=template&id=10171a4a&"
import script from "./VaItemLabel.vue?vue&type=script&lang=js&"
export * from "./VaItemLabel.vue?vue&type=script&lang=js&"
import style0 from "./VaItemLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports